import React, { useEffect, useMemo, useState } from "react";
import { signOut } from "firebase/auth";
import {
  collection,
  doc,
  onSnapshot,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { auth, db } from "../../../firebaseConfig";

const LOGO_DATA =
  "data:image/jpeg;base64,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";

const MODULES = [
  {
    key: "overview",
    title: "Dashboard Overview",
    desc: "National MIS, coverage and workflow analytics.",
    icon: "▣",
    tone: "green",
  },
  {
    key: "branchApproval",
    title: "State Branch Approval",
    desc: "Verify, approve or delete State Branch registrations.",
    icon: "✓",
    tone: "green",
  },
  {
    key: "projects",
    title: "Project Registry",
    desc: "Monitor all NAFED grain storage projects.",
    icon: "▤",
    tone: "blue",
  },
  {
    key: "dpr",
    title: "DPR Management",
    desc: "Survey, soil test, design, estimate and DPR.",
    icon: "▦",
    tone: "purple",
  },
  {
    key: "tender",
    title: "Tender Management",
    desc: "Tender publication, bids and L1 tracking.",
    icon: "▥",
    tone: "orange",
  },
  {
    key: "loa",
    title: "LOA / Work Orders",
    desc: "LOA issuance and work order control.",
    icon: "◫",
    tone: "teal",
  },
  {
    key: "ra",
    title: "RA Bill Management",
    desc: "RA bill verification, approval and payment.",
    icon: "₹",
    tone: "pink",
  },
  {
    key: "progress",
    title: "Progress Monitoring",
    desc: "Physical progress, milestones and delays.",
    icon: "▨",
    tone: "blue",
  },
  {
    key: "states",
    title: "State Monitoring",
    desc: "State and Branch-wise programme performance.",
    icon: "▧",
    tone: "green",
  },
  {
    key: "districts",
    title: "District Monitoring",
    desc: "District-wise coverage and performance.",
    icon: "⌖",
    tone: "orange",
  },
  {
    key: "pacs",
    title: "PACS Registry",
    desc: "PACS registrations, allocation and status.",
    icon: "▰",
    tone: "purple",
  },
  {
    key: "pmc",
    title: "PMC Agencies",
    desc: "PMC approvals and PACS-wise allocations.",
    icon: "▥",
    tone: "teal",
  },
  {
    key: "registrationMis",
    title: "Registration MIS",
    desc: "Live PACS, PMC, Vendor and Branch registration register.",
    icon: "MIS",
    tone: "green",
  },
  {
    key: "contractors",
    title: "Contractors",
    desc: "Contractor register and awarded works.",
    icon: "▤",
    tone: "blue",
  },
  {
    key: "banks",
    title: "Bank Coordination",
    desc: "Bank linkage and finance monitoring.",
    icon: "▣",
    tone: "green",
  },
  {
    key: "reports",
    title: "MIS Reports",
    desc: "National operational and financial reports.",
    icon: "▦",
    tone: "purple",
  },
  {
    key: "users",
    title: "Users & Roles",
    desc: "Role approvals and access governance.",
    icon: "✓",
    tone: "green",
  },
  {
    key: "notifications",
    title: "Notifications",
    desc: "System alerts and communication queue.",
    icon: "◉",
    tone: "orange",
  },
  {
    key: "audit",
    title: "Audit Trail",
    desc: "Immutable user and workflow activity logs.",
    icon: "▰",
    tone: "teal",
  },
  {
    key: "settings",
    title: "Portal Settings",
    desc: "National portal configuration.",
    icon: "⚙",
    tone: "blue",
  },
];

const clean = (v = "") =>
  String(v || "")
    .trim()
    .toLowerCase();
const upper = (v = "") =>
  String(v || "")
    .trim()
    .toUpperCase();
const human = (v = "-") =>
  String(v || "-")
    .replaceAll("_", " ")
    .toLowerCase()
    .replace(/\b\w/g, (x) => x.toUpperCase());
const timeOf = (v) =>
  v?.seconds ||
  (v?.toDate
    ? Math.floor(v.toDate().getTime() / 1000)
    : Math.floor(new Date(v || 0).getTime() / 1000)) ||
  0;
const dateTime = (v) => {
  try {
    const d = v?.toDate ? v.toDate() : new Date(v);
    return Number.isNaN(d.getTime())
      ? "-"
      : d.toLocaleString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
  } catch {
    return "-";
  }
};
const parseMetricNumber = (value) => {
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;
  if (value === null || value === undefined || value === "") return 0;
  const text = String(value).trim().toUpperCase().replaceAll(",", "");
  const parsed = Number.parseFloat(text.replace(/[^0-9.+-]/g, ""));
  if (!Number.isFinite(parsed)) return 0;
  if (text.includes("MMT")) return parsed * 1000000;
  if (text.includes("LMT") || text.includes("LAKH")) return parsed * 100000;
  if (text.includes("KMT")) return parsed * 1000;
  return parsed;
};
const firstMetric = (...values) => {
  for (const value of values) {
    if (value !== null && value !== undefined && value !== "") {
      const parsed = parseMetricNumber(value);
      if (parsed > 0) return parsed;
    }
  }
  return 0;
};
const number = (v) => parseMetricNumber(v).toLocaleString("en-IN");
const capacity = (p = {}) =>
  firstMetric(
    p.capacityMt,
    p.capacityMT,
    p.capacityInMt,
    p.capacityInMT,
    p.proposedCapacityMt,
    p.proposedCapacityMT,
    p.sanctionedCapacityMt,
    p.sanctionedCapacityMT,
    p.godownCapacityMt,
    p.godownCapacityMT,
    p.godownCapacity,
    p.storageCapacityMt,
    p.storageCapacityMT,
    p.storageCapacity,
    p.capacity,
    p.projectCapacity,
  );
const capacityText = (v) => {
  const total = parseMetricNumber(v);
  return total >= 100000
    ? `${(total / 100000).toFixed(2)} LMT`
    : `${number(total)} MT`;
};
const isNafed = (p = {}) =>
  p.nafedProject === true ||
  upper(p.projectSource) === "NAFED" ||
  upper(p.applicationPortal) === "NAFED_PACS_APPLY" ||
  upper(p.portal) === "NAFED";
const REMOVED = new Set([
  "DELETED",
  "REMOVED",
  "TRASHED",
  "ARCHIVED",
  "SOFT_DELETED",
  "PURGED",
]);
const deleted = (x = {}) =>
  x.isDeleted === true ||
  x.deleted === true ||
  x.archived === true ||
  x.isArchived === true ||
  x.pacsDeleted === true ||
  x.pacsIsDeleted === true ||
  Boolean(x.deletedAt || x.deletedByUid || x.archivedAt || x.removedAt) ||
  [
    x.status,
    x.recordStatus,
    x.registrationStatus,
    x.applicationStatus,
    x.deletionStatus,
    x.pacsStatus,
    x.archiveStatus,
  ].some((v) => REMOVED.has(upper(v)));
const pacsKeys = (x = {}) =>
  [
    x.id,
    x.pacsUid,
    x.pacsUserUid,
    x.pacsId,
    x.societyUid,
    x.ownerUid,
    x.pacsRegistrationNo,
    x.registrationNumber,
    x.pacsEmail,
    x.email,
    x.pacsName,
    x.societyName,
    x.cooperativeName,
  ]
    .map(clean)
    .filter(Boolean);
const pacsIdentity = (x = {}) => {
  const uid = clean(
    x.pacsUid ||
      x.pacsUserUid ||
      x.societyUid ||
      x.ownerUid ||
      x.uid ||
      x.userUid,
  );
  if (uid) return `uid:${uid}`;
  const registration = clean(
    x.pacsRegistrationNo ||
      x.registrationNumber ||
      x.registrationNo ||
      x.societyRegistrationNo,
  );
  if (registration) return `reg:${registration}`;
  const email = clean(x.pacsEmail || x.email || x.contactEmail);
  if (email) return `email:${email}`;
  const name = clean(
    x.pacsName || x.societyName || x.cooperativeName || x.organizationName,
  );
  const location = [
    x.state || x.stateName,
    x.district || x.districtName,
    x.taluka || x.block,
    x.village,
  ]
    .map(clean)
    .filter(Boolean)
    .join("|");
  return name ? `name:${name}|${location}` : `id:${clean(x.id)}`;
};
const projectIdentity = (x = {}) =>
  clean(x.applicationId || x.applicationNo || x.projectId || x.id);
const dedupeRecords = (rows, identity) => {
  const result = new Map();
  [...rows]
    .sort(
      (a, b) =>
        timeOf(a.updatedAt || a.createdAt) -
        timeOf(b.updatedAt || b.createdAt),
    )
    .forEach((row) => {
      const key = identity(row);
      if (!key) return;
      result.set(key, { ...(result.get(key) || {}), ...row });
    });
  return [...result.values()];
};
const allocationIsActive = (x = {}) =>
  !deleted(x) &&
  ![
    "INACTIVE",
    "UNALLOCATED",
    "REVOKED",
    "CANCELLED",
    "SUPERSEDED",
    "REJECTED",
  ].includes(upper(x.status || x.allocationStatus || x.event)) &&
  !x.unallocatedAt &&
  !x.revokedAt;
const projectName = (p = {}) =>
  p.applicationId ||
  p.projectName ||
  p.pacsName ||
  p.societyName ||
  p.organizationName ||
  p.id ||
  "NAFED Project";
const statusOf = (x = {}) =>
  upper(
    x.roleApprovalStatus ||
      x.approvalStatus ||
      x.registrationStatus ||
      x.applicationStatus ||
      x.status,
  );

function useLiveCollection(name, setter) {
  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, name),
      (snap) => setter(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
      (error) => console.warn(`${name} live feed unavailable`, error),
    );
    return unsubscribe;
  }, [name, setter]);
}

function ModuleCard({ item, onOpen }) {
  return (
    <button className="ho-module" onClick={() => onOpen(item)}>
      <span className={`ho-icon ${item.tone}`}>{item.icon}</span>
      <span>
        <b>{item.title}</b>
        <small>{item.desc}</small>
      </span>
      <em>›</em>
    </button>
  );
}

function Kpi({ label, value, note, tone }) {
  return (
    <div className={`ho-kpi ${tone}`}>
      <span>{label}</span>
      <b>{value}</b>
      <small>{note}</small>
    </div>
  );
}

export default function NafedHeadDashboard() {
  const [tab, setTab] = useState("home");
  const [projects, setProjects] = useState([]);
  const [users, setUsers] = useState([]);
  const [allocations, setAllocations] = useState([]);
  const [activities, setActivities] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [tenders, setTenders] = useState([]);
  const [mous, setMous] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [bills, setBills] = useState([]);
  const [payments, setPayments] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [vendorRegistrations, setVendorRegistrations] = useState([]);
  const [workflowVendors, setWorkflowVendors] = useState([]);
  const [actionBusy, setActionBusy] = useState("");
  const [actionMessage, setActionMessage] = useState("");
  const [search, setSearch] = useState("");
  const [newsIndex, setNewsIndex] = useState(0);
  const [clock, setClock] = useState(new Date());

  useLiveCollection("godown_projects", setProjects);
  useLiveCollection("nafed_users", setUsers);
  useLiveCollection("pacs_pmc_allocations", setAllocations);
  useLiveCollection("nafed_activity", setActivities);
  useLiveCollection("nafed_notifications", setNotifications);
  useLiveCollection("nafed_tenders", setTenders);
  useLiveCollection("nafed_mous", setMous);
  useLiveCollection("nafed_documents", setDocuments);
  useLiveCollection("nafed_ra_bills", setBills);
  useLiveCollection("nafed_payments", setPayments);
  useLiveCollection("wf_project_tasks", setTasks);
  useLiveCollection("vendor_registrations", setVendorRegistrations);
  useLiveCollection("workflow_vendors", setWorkflowVendors);

  useEffect(() => {
    const id = setInterval(() => setClock(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const validUsers = useMemo(() => users.filter((x) => !deleted(x)), [users]);
  const validPacsUsers = useMemo(
    () =>
      dedupeRecords(
        validUsers.filter((u) =>
          ["PACS", "PACS_SOCIETY", "PACS / SOCIETY"].includes(upper(u.role)),
        ),
        pacsIdentity,
      ),
    [validUsers],
  );
  const deletedPacsKeys = useMemo(() => {
    const keys = new Set();
    users
      .filter(
        (u) =>
          deleted(u) &&
          ["PACS", "PACS_SOCIETY", "PACS / SOCIETY"].includes(upper(u.role)),
      )
      .forEach((u) => pacsKeys(u).forEach((k) => keys.add(k)));
    return keys;
  }, [users]);
  const validProjects = useMemo(
    () =>
      dedupeRecords(
        projects.filter(
          (p) =>
            isNafed(p) &&
            !deleted(p) &&
            !pacsKeys(p).some((k) => deletedPacsKeys.has(k)),
        ),
        projectIdentity,
      ),
    [projects, deletedPacsKeys],
  );
  const vendors = useMemo(() => {
    const map = new Map();
    [
      ...validUsers.filter((u) =>
        ["VENDOR", "TECHNICAL_VENDOR", "WORKFLOW_VENDOR"].includes(
          upper(u.role),
        ),
      ),
      ...vendorRegistrations.filter((v) => !deleted(v)),
      ...workflowVendors.filter((v) => !deleted(v)),
    ].forEach((v) => {
      const key = clean(
        v.uid || v.userUid || v.email || v.registrationNumber || v.id,
      );
      if (key) map.set(key, { ...(map.get(key) || {}), ...v });
    });
    return [...map.values()];
  }, [validUsers, vendorRegistrations, workflowVendors]);
  const activeAllocations = useMemo(() => {
    const identityByAlias = new Map();
    validPacsUsers.forEach((user) => {
      const identity = pacsIdentity(user);
      pacsKeys(user).forEach((alias) => identityByAlias.set(alias, identity));
      identityByAlias.set(clean(user.id), identity);
    });
    const latestByPacs = new Map();
    allocations
      .filter(allocationIsActive)
      .sort(
        (a, b) =>
          timeOf(b.updatedAt || b.allocatedAt || b.createdAt) -
          timeOf(a.updatedAt || a.allocatedAt || a.createdAt),
      )
      .forEach((item) => {
        const identity =
          pacsKeys(item)
            .map((key) => identityByAlias.get(key))
            .find(Boolean) || identityByAlias.get(clean(item.pacsUid));
        if (identity && !latestByPacs.has(identity))
          latestByPacs.set(identity, item);
      });
    return [...latestByPacs.values()];
  }, [allocations, validPacsUsers]);
  const stats = useMemo(() => {
    const branches = dedupeRecords(
      validUsers.filter((u) => upper(u.role) === "STATE_BRANCH"),
      (u) => clean(u.uid || u.email || u.state || u.id),
    );
    const pmcs = dedupeRecords(
      validUsers.filter((u) => upper(u.role) === "PMC"),
      (u) => clean(u.uid || u.email || u.registrationNumber || u.id),
    );
    const states = new Set(
      [...validProjects, ...branches]
        .map((p) => clean(p.state || p.stateName))
        .filter(Boolean),
    );
    const districts = new Set(
      validProjects
        .map((p) => clean(p.district || p.districtName))
        .filter(Boolean),
    );
    const appliedPacs = new Set(
      validProjects.map((p) => pacsIdentity(p)).filter(Boolean),
    );
    return {
      projects: validProjects.length,
      states: states.size,
      districts: districts.size,
      pacs: validPacsUsers.length,
      appliedPacs: appliedPacs.size,
      vendors: vendors.length,
      approvedVendors: vendors.filter(
        (v) => statusOf(v) === "APPROVED" || upper(v.shineAgriStatus) === "APPROVED",
      ).length,
      capacity: validProjects.reduce((s, p) => s + capacity(p), 0),
      branches: branches.length,
      pendingBranches: branches.filter((x) => statusOf(x).includes("PENDING"))
        .length,
      approvedBranches: branches.filter((x) => statusOf(x) === "APPROVED")
        .length,
      pmcs: pmcs.length,
      approvedPmcs: pmcs.filter((x) => statusOf(x) === "APPROVED").length,
      allocations: activeAllocations.length,
      tenders: tenders.filter((x) => !deleted(x)).length,
      activeTenders: tenders.filter(
        (x) =>
          !deleted(x) &&
          !["CLOSED", "CANCELLED", "AWARDED"].includes(upper(x.status)),
      ).length,
      mous: mous.filter((x) => !deleted(x)).length,
      executedMous: mous.filter(
        (x) =>
          !deleted(x) &&
          ["FULLY_EXECUTED", "EXECUTED", "COMPLETED"].includes(
            upper(x.status || x.mouStatus),
          ),
      ).length,
      bills: bills.filter((x) => !deleted(x)).length,
      payments: payments.filter((x) => !deleted(x)).length,
    };
  }, [
    validProjects,
    validUsers,
    validPacsUsers,
    activeAllocations,
    tenders,
    mous,
    bills,
    payments,
    vendors,
  ]);

  const news = useMemo(() => {
    const rows = [];
    activities
      .filter((x) => !deleted(x))
      .forEach((x) =>
        rows.push({
          id: `a-${x.id}`,
          time: x.createdAt || x.performedAt || x.updatedAt,
          text:
            x.message ||
            x.description ||
            `${human(x.action)} by ${x.performedByName || x.performedByRole || "Portal User"}`,
          type: "Activity",
        }),
      );
    activeAllocations.forEach((x) =>
      rows.push({
        id: `l-${x.id}`,
        time: x.updatedAt || x.createdAt,
        text: `${x.pacsName || "PACS"} ${human(x.event || x.status || "allocated")} ${x.pmcName ? `to ${x.pmcName}` : ""}`,
        type: "PMC Allocation",
      }),
    );
    validProjects.forEach((x) =>
      rows.push({
        id: `p-${x.id}`,
        time: x.updatedAt || x.createdAt,
        text: `${projectName(x)} — ${human(x.status || x.workflowStage || "Application received")}`,
        type: "Project",
      }),
    );
    validUsers
      .filter((x) => x.createdAt || x.updatedAt)
      .forEach((x) =>
        rows.push({
          id: `u-${x.id}`,
          time: x.updatedAt || x.createdAt,
          text: `${x.organizationName || x.name || x.email || human(x.role)} — ${human(x.status || "registered")}`,
          type: "Registration",
        }),
      );
    tenders
      .filter((x) => !deleted(x))
      .forEach((x) =>
        rows.push({
          id: `t-${x.id}`,
          time: x.updatedAt || x.publishedAt || x.createdAt,
          text: `Tender ${x.tenderNo || x.tenderNumber || x.title || x.id} — ${human(x.status || "published")}${x.pacsName ? ` for ${x.pacsName}` : ""}`,
          type: "Tender",
        }),
      );
    mous
      .filter((x) => !deleted(x))
      .forEach((x) =>
        rows.push({
          id: `m-${x.id}`,
          time: x.updatedAt || x.executedAt || x.createdAt,
          text: `MOU ${x.mouNumber || x.mouNo || x.id} — ${human(x.mouStatus || x.status || "generated")}`,
          type: "MOU",
        }),
      );
    documents
      .filter((x) => !deleted(x))
      .forEach((x) =>
        rows.push({
          id: `d-${x.id}`,
          time: x.updatedAt || x.uploadedAt || x.createdAt,
          text: `${x.documentName || x.title || x.type || "Document"} — ${human(x.status || "uploaded")}`,
          type: "Document",
        }),
      );
    bills
      .filter((x) => !deleted(x))
      .forEach((x) =>
        rows.push({
          id: `b-${x.id}`,
          time: x.updatedAt || x.submittedAt || x.createdAt,
          text: `RA Bill ${x.billNumber || x.raBillNo || x.id} — ${human(x.status || "submitted")}`,
          type: "RA Bill",
        }),
      );
    payments
      .filter((x) => !deleted(x))
      .forEach((x) =>
        rows.push({
          id: `pay-${x.id}`,
          time: x.updatedAt || x.paidAt || x.createdAt,
          text: `Payment ${x.paymentNumber || x.referenceNo || x.id} — ${human(x.status || "updated")}`,
          type: "Payment",
        }),
      );
    tasks
      .filter((x) => !deleted(x))
      .forEach((x) =>
        rows.push({
          id: `task-${x.id}`,
          time: x.updatedAt || x.completedAt || x.createdAt,
          text: `${human(x.taskType || x.title || "Project task")} — ${human(x.status || "updated")}`,
          type: "Workflow",
        }),
      );
    notifications
      .filter((x) => !deleted(x))
      .forEach((x) =>
        rows.push({
          id: `n-${x.id}`,
          time: x.updatedAt || x.createdAt,
          text: x.message || x.title || "New portal notification",
          type: "Notice",
        }),
      );
    return rows
      .filter((x) => timeOf(x.time) > 0)
      .sort((a, b) => timeOf(b.time) - timeOf(a.time))
      .slice(0, 60);
  }, [
    activities,
    activeAllocations,
    validProjects,
    validUsers,
    tenders,
    mous,
    documents,
    bills,
    payments,
    tasks,
    notifications,
  ]);

  useEffect(() => {
    if (!news.length) return;
    const id = setInterval(
      () => setNewsIndex((i) => (i + 1) % news.length),
      5000,
    );
    return () => clearInterval(id);
  }, [news.length]);
  useEffect(() => setNewsIndex(0), [news.length]);

  const recent = useMemo(
    () =>
      [...validProjects]
        .sort(
          (a, b) =>
            timeOf(b.updatedAt || b.createdAt) -
            timeOf(a.updatedAt || a.createdAt),
        )
        .slice(0, 8),
    [validProjects],
  );
  const statuses = useMemo(() => {
    const m = {};
    validProjects.forEach((p) => {
      const s = upper(p.status || p.workflowStage || p.stage || "APPLIED");
      m[s] = (m[s] || 0) + 1;
    });
    return Object.entries(m)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 6);
  }, [validProjects]);
  const moduleList = useMemo(
    () =>
      MODULES.filter((x) =>
        clean(`${x.title} ${x.desc}`).includes(clean(search)),
      ),
    [search],
  );
  const unread = notifications.filter(
    (x) => x.read !== true && upper(x.status) !== "READ",
  ).length;
  const branches = useMemo(
    () =>
      validUsers
        .filter((u) => upper(u.role) === "STATE_BRANCH")
        .sort(
          (a, b) =>
            timeOf(b.updatedAt || b.createdAt) -
            timeOf(a.updatedAt || a.createdAt),
        ),
    [validUsers],
  );

  const approveBranch = async (branch) => {
    if (
      !window.confirm(
        `Approve State Branch: ${branch.organizationName || branch.name || branch.email}?`,
      )
    )
      return;
    try {
      setActionBusy(branch.id);
      setActionMessage("");
      await updateDoc(doc(db, "nafed_users", branch.id), {
        status: "APPROVED",
        approvalStatus: "APPROVED",
        approvedByUid: auth.currentUser?.uid || "",
        approvedByRole: "HEAD_OFFICE",
        approvedAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });
      setActionMessage("State Branch approved successfully.");
    } catch (e) {
      setActionMessage(
        e?.message || "Approval failed. Check Firestore permission.",
      );
    } finally {
      setActionBusy("");
    }
  };
  const deleteBranch = async (branch) => {
    const name =
      branch.organizationName || branch.name || branch.email || branch.id;
    if (
      !window.confirm(
        `Delete ${name}? This will permanently remove this State Branch record.`,
      )
    )
      return;
    if (
      !window.confirm(
        "Final confirmation: this action cannot be undone. Continue?",
      )
    )
      return;
    try {
      setActionBusy(branch.id);
      setActionMessage("");
      await updateDoc(doc(db, "nafed_users", branch.id), {
        isDeleted: true,
        deleted: true,
        status: "DELETED",
        recordStatus: "DELETED",
        isActive: false,
        deletedAt: serverTimestamp(),
        deletedByUid: auth.currentUser?.uid || "",
        deletedByRole: "HEAD_OFFICE",
        updatedAt: serverTimestamp(),
      });
      setActionMessage(
        "State Branch record removed successfully and preserved in the audit trail.",
      );
    } catch (e) {
      setActionMessage(
        e?.message ||
          "Delete failed. Head Office delete permission is required.",
      );
    } finally {
      setActionBusy("");
    }
  };

  const logout = async () => {
    await signOut(auth);
    window.location.href = "/nafed";
  };
  const openModule = (item) =>
    item.path ? window.location.assign(item.path) : setTab(item.key);
  const active = MODULES.find((x) => x.key === tab);

  const renderBranchApproval = () => (
    <div className="ho-overview">
      <section className="ho-kpis six">
        <Kpi
          label="Total Branches"
          value={stats.branches}
          note="Live registrations"
          tone="navy"
        />
        <Kpi
          label="Approved"
          value={stats.approvedBranches}
          note="Head Office approved"
          tone="green"
        />
        <Kpi
          label="Pending"
          value={stats.pendingBranches}
          note="Action required"
          tone="orange"
        />
      </section>
      {actionMessage && <div className="action-message">{actionMessage}</div>}
      <section className="ho-panel">
        <header>
          <h3>State Branch Registration Approval Register</h3>
          <span>{branches.length} live records</span>
        </header>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>State Branch / Organisation</th>
                <th>State</th>
                <th>Contact</th>
                <th>Email</th>
                <th>Status</th>
                <th>Registered</th>
                <th>Head Office Action</th>
              </tr>
            </thead>
            <tbody>
              {branches.map((b) => (
                <tr key={b.id}>
                  <td>
                    <b>
                      {b.organizationName ||
                        b.branchName ||
                        b.name ||
                        "State Branch"}
                    </b>
                    <small className="record-id">
                      {b.registrationNo || b.id}
                    </small>
                  </td>
                  <td>{b.state || b.stateName || "-"}</td>
                  <td>{b.mobile || b.phone || b.contactNumber || "-"}</td>
                  <td>{b.email || "-"}</td>
                  <td>
                    <span
                      className={`status-tag ${upper(b.status).includes("PENDING") ? "pending" : ""}`}
                    >
                      {human(b.status || "Pending")}
                    </span>
                  </td>
                  <td>{dateTime(b.createdAt)}</td>
                  <td>
                    <div className="row-actions">
                      <button
                        className="approve-btn"
                        disabled={
                          actionBusy === b.id || upper(b.status) === "APPROVED"
                        }
                        onClick={() => approveBranch(b)}
                      >
                        {upper(b.status) === "APPROVED"
                          ? "Approved"
                          : "Approve"}
                      </button>
                      <button
                        className="delete-btn"
                        disabled={actionBusy === b.id}
                        onClick={() => deleteBranch(b)}
                      >
                        {actionBusy === b.id ? "Please wait..." : "Delete"}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {!branches.length && (
                <tr>
                  <td colSpan="7" className="empty">
                    No State Branch registration found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );

  const registrationRows = useMemo(
    () =>
      validUsers
        .filter((u) =>
          [
            "PACS",
            "PACS_SOCIETY",
            "PACS / SOCIETY",
            "PMC",
            "STATE_BRANCH",
          ].includes(upper(u.role)),
        )
        .concat(vendors.map((v) => ({ ...v, role: v.role || "VENDOR" })))
        .sort(
          (a, b) =>
            timeOf(b.updatedAt || b.createdAt) -
            timeOf(a.updatedAt || a.createdAt),
        ),
    [validUsers, vendors],
  );
  const renderRegistrationMis = () => (
    <div className="ho-overview">
      <section className="ho-kpis six">
        <Kpi
          label="Registered PACS"
          value={stats.pacs}
          note={`${stats.appliedPacs} with application`}
          tone="green"
        />
        <Kpi
          label="PMC Agencies"
          value={stats.pmcs}
          note={`${stats.approvedPmcs} approved`}
          tone="navy"
        />
        <Kpi
          label="Technical Vendors"
          value={stats.vendors}
          note={`${stats.approvedVendors} approved`}
          tone="orange"
        />
        <Kpi
          label="State Branches"
          value={stats.branches}
          note={`${stats.approvedBranches} approved`}
          tone="green"
        />
      </section>
      <section className="ho-panel">
        <header>
          <h3>National Registration Master</h3>
          <span>
            {registrationRows.length} active records · deleted records excluded
          </span>
        </header>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Role</th>
                <th>Organisation / Society</th>
                <th>Registration</th>
                <th>State / District</th>
                <th>Contact</th>
                <th>Approval Status</th>
                <th>Registered / Updated</th>
              </tr>
            </thead>
            <tbody>
              {registrationRows.map((r) => (
                <tr key={`${upper(r.role)}-${r.id}`}>
                  <td>
                    <b>{human(r.role)}</b>
                  </td>
                  <td>
                    <b>
                      {r.organizationName ||
                        r.societyName ||
                        r.pacsName ||
                        r.agencyName ||
                        r.companyName ||
                        r.name ||
                        "-"}
                    </b>
                    <small className="record-id">{r.email || "-"}</small>
                  </td>
                  <td>
                    {r.registrationNumber ||
                      r.registrationNo ||
                      r.pacsRegistrationNo ||
                      r.id}
                  </td>
                  <td>
                    <b>{r.state || r.stateName || "All India"}</b>
                    <small className="record-id">
                      {[r.district, r.taluka, r.village]
                        .filter(Boolean)
                        .join(" · ") || "-"}
                    </small>
                  </td>
                  <td>{r.mobile || r.phone || r.contactNumber || "-"}</td>
                  <td>
                    <span
                      className={`status-tag ${upper(r.status || r.approvalStatus).includes("PENDING") ? "pending" : ""}`}
                    >
                      {human(
                        r.status ||
                          r.approvalStatus ||
                          r.shineAgriStatus ||
                          "Registered",
                      )}
                    </span>
                  </td>
                  <td>{dateTime(r.updatedAt || r.createdAt)}</td>
                </tr>
              ))}
              {!registrationRows.length && (
                <tr>
                  <td colSpan="7" className="empty">
                    No active registration found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );

  const renderOverview = () => (
    <div className="ho-overview">
      <section className="overview-command">
        <div>
          <small>NAFED NATIONAL CONTROL ROOM</small>
          <h3>Integrated Grain Storage Programme Overview</h3>
          <p>
            Real-time registration, allocation, MOU, tender, DPR and execution
            monitoring from one authorised dashboard.
          </p>
        </div>
        <div className="command-live">
          <i />
          <span>LIVE FIRESTORE</span>
          <b>{dateTime(clock)}</b>
        </div>
      </section>
      <section className="ho-kpis six">
        <Kpi
          label="Total Projects"
          value={number(stats.projects)}
          note="Active NAFED projects"
          tone="green"
        />
        <Kpi
          label="Storage Capacity"
          value={capacityText(stats.capacity)}
          note="National capacity"
          tone="navy"
        />
        <Kpi
          label="PACS Registered"
          value={stats.pacs}
          note={`${stats.appliedPacs} applications`}
          tone="navy"
        />
        <Kpi
          label="Active Allocations"
          value={stats.allocations}
          note={`${Math.max(0, stats.pacs - stats.allocations)} PACS awaiting allocation`}
          tone="green"
        />
        <Kpi
          label="Technical Vendors"
          value={stats.vendors}
          note={`${stats.approvedVendors} approved`}
          tone="orange"
        />
        <Kpi
          label="Active Tenders"
          value={stats.activeTenders}
          note={`${stats.tenders} total tenders`}
          tone="green"
        />
      </section>
      <section className="control-strip">
        <div>
          <span>Registration Coverage</span>
          <b>{stats.pacs} PACS</b>
          <small>Deleted/archived accounts excluded</small>
        </div>
        <div>
          <span>PMC Control</span>
          <b>{stats.approvedPmcs} Approved</b>
          <small>{stats.pmcs} total agencies</small>
        </div>
        <div>
          <span>Allocation Coverage</span>
          <b>
            {stats.pacs
              ? Math.round((stats.allocations / stats.pacs) * 100)
              : 0}
            %
          </b>
          <small>Unique latest PACS allocations only</small>
        </div>
        <div>
          <span>Project Conversion</span>
          <b>{stats.projects}</b>
          <small>Applications converted to projects</small>
        </div>
      </section>
      <section className="ho-grid two">
        <div className="ho-panel">
          <header>
            <h3>Project Status Summary</h3>
            <span>Live Firestore data</span>
          </header>
          <div className="status-bars">
            {statuses.map(([name, val], i) => (
              <div key={name}>
                <label>
                  <span>{human(name)}</span>
                  <b>{val}</b>
                </label>
                <i>
                  <em
                    style={{
                      width: `${stats.projects ? Math.max(4, (val / stats.projects) * 100) : 0}%`,
                      background: [
                        "#145a32",
                        "#174f87",
                        "#d17b16",
                        "#6b4ca5",
                        "#0f766e",
                        "#8b2f3f",
                      ][i],
                    }}
                  />
                </i>
              </div>
            ))}
            {!statuses.length && <p>No project status available.</p>}
          </div>
        </div>
        <div className="ho-panel">
          <header>
            <h3>Approval Control</h3>
            <span>Registration governance</span>
          </header>
          <div className="approval-list">
            <p>
              <span>State Branch Approved</span>
              <b>{stats.approvedBranches}</b>
            </p>
            <p>
              <span>State Branch Pending</span>
              <b className="amber">{stats.pendingBranches}</b>
            </p>
            <p>
              <span>Approved PMC Agencies</span>
              <b>{stats.approvedPmcs}</b>
            </p>
            <p>
              <span>Active PACS Allocations</span>
              <b>{stats.allocations}</b>
            </p>
          </div>
        </div>
      </section>
      <section className="ho-panel">
        <header>
          <h3>National Workflow Control</h3>
          <span>All connected live modules</span>
        </header>
        <div className="workflow-cards">
          <div>
            <span>PACS–PMC Allocations</span>
            <b>{stats.allocations}</b>
          </div>
          <div>
            <span>Registered Vendors</span>
            <b>{stats.vendors}</b>
          </div>
          <div>
            <span>Total Tenders</span>
            <b>{stats.tenders}</b>
          </div>
          <div>
            <span>MOU Records</span>
            <b>{stats.mous}</b>
          </div>
          <div>
            <span>RA Bills</span>
            <b>{stats.bills}</b>
          </div>
          <div>
            <span>Payments</span>
            <b>{stats.payments}</b>
          </div>
        </div>
      </section>
      <section className="ho-panel">
        <header>
          <h3>Recent NAFED Projects</h3>
          <span>Latest eight active records</span>
        </header>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Application / Project</th>
                <th>State</th>
                <th>District</th>
                <th>PACS / Society</th>
                <th>Capacity</th>
                <th>Status</th>
                <th>Updated</th>
              </tr>
            </thead>
            <tbody>
              {recent.map((r) => (
                <tr key={r.id}>
                  <td>
                    <b>{r.applicationId || r.projectId || r.id}</b>
                  </td>
                  <td>{r.state || "-"}</td>
                  <td>{r.district || "-"}</td>
                  <td>
                    {r.pacsName || r.societyName || r.organizationName || "-"}
                  </td>
                  <td>{capacityText(capacity(r))}</td>
                  <td>
                    <span className="status-tag">
                      {human(r.status || r.workflowStage || "Applied")}
                    </span>
                  </td>
                  <td>{dateTime(r.updatedAt || r.createdAt)}</td>
                </tr>
              ))}
              {!recent.length && (
                <tr>
                  <td colSpan="7" className="empty">
                    No active NAFED project found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );

  return (
    <div className="ho-page">
      <style>{CSS}</style>
      <header className="gov-head">
        <div className="gov-brand">
          <img src={LOGO_DATA} alt="NAFED" />
          <div>
            <h1>NAFED Head Office Portal</h1>
            <p>National Grain Storage Digital Monitoring System</p>
          </div>
        </div>
        <div className="gov-right">
          <div className="date">
            <b>
              {clock.toLocaleTimeString("en-IN", {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </b>
            <span>
              {clock.toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </span>
          </div>
          <button className="bell" onClick={() => setTab("notifications")}>
            Alerts <i>{unread}</i>
          </button>
          <span className="avatar">HO</span>
          <button className="logout" onClick={logout}>
            Logout
          </button>
        </div>
      </header>
      <div className="news">
        <b>Latest Updates</b>
        <div className="news-window">
          {news.length ? (
            <span key={news[newsIndex]?.id}>
              <em>{news[newsIndex]?.type}</em>
              {news[newsIndex]?.text}
              <small>{dateTime(news[newsIndex]?.time)}</small>
            </span>
          ) : (
            <span>No latest workflow update is available.</span>
          )}
        </div>
        <div className="news-nav">
          <button
            onClick={() =>
              setNewsIndex((i) => (i - 1 + news.length) % news.length)
            }
            disabled={!news.length}
          >
            ‹
          </button>
          <button
            onClick={() => setNewsIndex((i) => (i + 1) % news.length)}
            disabled={!news.length}
          >
            ›
          </button>
        </div>
      </div>
      <main className="ho-main">
        {tab === "home" ? (
          <>
            <section className="welcome">
              <div>
                <small>GOVERNMENT OF INDIA · NATIONAL PROGRAMME MIS</small>
                <h2>NAFED Head Office Dashboard</h2>
                <p>
                  National monitoring and governance of PACS grain storage
                  infrastructure.
                </p>
              </div>
              <div className="quick">
                <span>
                  <b>{stats.states}</b>States
                </span>
                <span>
                  <b>{stats.projects}</b>Projects
                </span>
                <span>
                  <b>{capacityText(stats.capacity)}</b>Capacity
                </span>
                <span>
                  <b>{stats.pacs}</b>PACS
                </span>
              </div>
            </section>
            {renderOverview()}
            <section className="module-box">
              <header>
                <div>
                  <h3>Head Office Services</h3>
                  <p>Select an authorised service to continue.</p>
                </div>
                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search services..."
                />
              </header>
              <div className="module-grid">
                {moduleList.map((x) => (
                  <ModuleCard key={x.key} item={x} onOpen={openModule} />
                ))}
              </div>
            </section>
          </>
        ) : (
          <section className="module-page">
            <header>
              <div>
                <small>NAFED HEAD OFFICE</small>
                <h2>{active?.title || "Dashboard Overview"}</h2>
                <p>{active?.desc || "National MIS and monitoring"}</p>
              </div>
              <button onClick={() => setTab("home")}>Back to Dashboard</button>
            </header>
            <div className="module-body">
              {tab === "overview" ? (
                renderOverview()
              ) : tab === "branchApproval" ? (
                renderBranchApproval()
              ) : tab === "registrationMis" ? (
                renderRegistrationMis()
              ) : (
                <div className="module-ready">
                  <span className={`ho-icon ${active?.tone || "green"}`}>
                    {active?.icon || "▣"}
                  </span>
                  <h3>{active?.title}</h3>
                  <p>
                    The existing authorised working module can be mounted here
                    without changing its business logic.
                  </p>
                </div>
              )}
            </div>
          </section>
        )}
      </main>
    </div>
  );
}

const CSS = `
.overview-command{display:flex;align-items:center;justify-content:space-between;gap:20px;padding:18px 20px;border:1px solid #1b436d;border-left:5px solid #168447;border-radius:6px;background:linear-gradient(105deg,#12345b,#16476a 58%,#17613f);color:#fff}.overview-command small{color:#bce4c7;font-size:9px;font-weight:900;letter-spacing:.09em}.overview-command h3{margin:5px 0;font-size:21px}.overview-command p{margin:0;color:#dbe7ef;font-size:11px}.command-live{min-width:165px;padding:11px 13px;border:1px solid #ffffff55;border-radius:5px;background:#ffffff13}.command-live i{display:inline-block;width:8px;height:8px;margin-right:7px;border-radius:50%;background:#55e58b;box-shadow:0 0 0 4px #55e58b22}.command-live span{font-size:9px;font-weight:900}.command-live b{display:block;margin-top:6px;font-size:10px}.control-strip{display:grid;grid-template-columns:repeat(4,1fr);border:1px solid #b7c2cc;border-radius:6px;background:#fff}.control-strip>div{padding:14px 16px;border-right:1px solid #cbd4dd}.control-strip>div:last-child{border:0}.control-strip span,.control-strip b,.control-strip small{display:block}.control-strip span{color:#687686;font-size:9px;text-transform:uppercase}.control-strip b{margin:5px 0;color:#12345b;font-size:17px}.control-strip small{color:#667482;font-size:9px}@media(max-width:900px){.overview-command{align-items:flex-start;flex-direction:column}.control-strip{grid-template-columns:repeat(2,1fr)}}@media(max-width:620px){.control-strip{grid-template-columns:1fr}.control-strip>div{border-right:0;border-bottom:1px solid #cbd4dd}}
*{box-sizing:border-box}body{margin:0;background:#edf1f4;color:#1f2937;font-family:Inter,"Segoe UI",Arial,sans-serif}.ho-page{min-height:100vh;background:#edf1f4}.gov-head{height:88px;background:#fff;border-top:4px solid transparent;border-image:linear-gradient(90deg,#e58a24 0 33.3%,#fff 33.3% 66.6%,#168447 66.6%) 1;border-bottom:1px solid #aeb9c4;display:flex;align-items:center;justify-content:space-between;padding:7px max(28px,calc((100vw - 1440px)/2))}.gov-brand,.gov-right{display:flex;align-items:center;gap:14px}.gov-brand img{width:68px;height:70px;object-fit:contain;mix-blend-mode:multiply}.gov-brand h1{margin:0;color:#12345b;font-size:22px;font-weight:800}.gov-brand p{margin:4px 0 0;color:#5b6876;font-size:11px}.gov-right .date{text-align:right;border-right:1px solid #cbd4dd;padding-right:13px}.date b,.date span{display:block}.date b{color:#12345b}.date span{font-size:10px;color:#637182}.bell,.logout{height:38px;border:1px solid #8292a3;background:#fff;color:#12345b;border-radius:5px;padding:0 12px;font-weight:700;cursor:pointer}.bell{position:relative}.bell i{font-style:normal;background:#b42318;color:#fff;border-radius:10px;padding:2px 6px;margin-left:5px;font-size:10px}.avatar{width:38px;height:38px;border:1px solid #8fb59b;border-radius:50%;background:#e9f3ec;color:#166534;display:grid;place-items:center;font-weight:800}.news{height:46px;background:#12345b;color:#fff;display:grid;grid-template-columns:auto 1fr auto;align-items:center;padding:0 max(28px,calc((100vw - 1440px)/2));overflow:hidden}.news>b{height:100%;display:flex;align-items:center;background:#168447;padding:0 17px;text-transform:uppercase;font-size:10px;letter-spacing:.08em}.news-window{overflow:hidden;padding:0 14px}.news-window>span{display:flex;align-items:center;gap:10px;white-space:nowrap;animation:newsIn .45s ease}.news-window em{font-style:normal;color:#f5c06d;font-size:10px;text-transform:uppercase}.news-window small{margin-left:auto;color:#c7d5e4}.news-nav{display:flex}.news-nav button{width:32px;height:28px;border:1px solid #ffffff55;background:transparent;color:#fff}.ho-main{width:min(1440px,calc(100% - 56px));margin:20px auto}.welcome{background:#fff;border:1px solid #b7c2cc;border-left:5px solid #168447;border-radius:6px;padding:19px 21px;display:flex;justify-content:space-between;align-items:center;gap:20px}.welcome small{color:#168447;font-weight:800;letter-spacing:.06em}.welcome h2{color:#12345b;margin:5px 0;font-size:25px}.welcome p{margin:0;color:#596878}.quick{display:grid;grid-template-columns:repeat(4,1fr);border:1px solid #bdc8d2;border-radius:5px;min-width:620px}.quick span{padding:11px 16px;border-right:1px solid #ccd5de;color:#617081;font-size:10px}.quick span:last-child{border:0}.quick b{display:block;color:#12345b;font-size:17px;margin-bottom:3px}.module-box,.ho-panel,.module-page{background:#fff;border:1px solid #b7c2cc;border-radius:6px;margin-top:14px}.module-box>header,.ho-panel>header{display:flex;align-items:center;justify-content:space-between;padding:14px 16px;border-bottom:2px solid #d4dce3}.module-box h3,.ho-panel h3{margin:0;color:#12345b;font-size:17px}.module-box p{margin:4px 0 0;color:#627181;font-size:11px}.module-box input{width:270px;height:38px;border:1px solid #899aaa;border-radius:4px;padding:0 11px}.module-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;padding:14px}.ho-module{min-height:92px;border:1px solid #c1ccd6;border-radius:5px;background:#fff;padding:12px;display:grid;grid-template-columns:46px 1fr 20px;align-items:center;gap:10px;text-align:left;cursor:pointer}.ho-module:hover{border-color:#168447;background:#f5faf7;box-shadow:0 0 0 1px #168447}.ho-icon{width:44px;height:44px;border-radius:4px;display:grid;place-items:center;font-size:19px;font-weight:800}.ho-icon.green{background:#e7f3eb;color:#166534}.ho-icon.blue{background:#e7eff8;color:#174f87}.ho-icon.purple{background:#f0eaf7;color:#674493}.ho-icon.orange{background:#fff0df;color:#a8520d}.ho-icon.teal{background:#e4f3f1;color:#0f655c}.ho-icon.pink{background:#f8e9ee;color:#94364f}.ho-module b,.ho-module small{display:block}.ho-module b{color:#12345b;font-size:13px}.ho-module small{color:#5f6e7d;font-size:10px;line-height:1.4;margin-top:4px}.ho-module em{font-style:normal;color:#168447;font-size:20px}.module-page{overflow:hidden}.module-page>header{background:#12345b;color:#fff;padding:15px 18px;display:flex;justify-content:space-between;align-items:center}.module-page>header small{color:#bce0c5}.module-page h2{margin:3px 0;font-size:21px}.module-page>header p{margin:0;color:#dbe6f0;font-size:11px}.module-page>header button{border:1px solid #fff;background:#fff;color:#12345b;border-radius:4px;padding:9px 12px;font-weight:700}.module-body{padding:14px;background:#f5f7f9}.module-ready{background:#fff;border:1px solid #c1ccd6;padding:50px;text-align:center}.module-ready .ho-icon{margin:auto}.ho-overview{display:grid;gap:12px}.ho-kpis{display:grid;gap:9px}.ho-kpis.six{grid-template-columns:repeat(6,1fr)}.ho-kpi{background:#fff;border:1px solid #bac6d0;border-top:3px solid #12345b;border-radius:5px;padding:13px}.ho-kpi.green{border-top-color:#168447}.ho-kpi.orange{border-top-color:#d17b16}.ho-kpi span,.ho-kpi b,.ho-kpi small{display:block}.ho-kpi span{font-size:9px;text-transform:uppercase;color:#637181}.ho-kpi b{color:#12345b;font-size:19px;margin:5px 0}.ho-kpi small{font-size:9px;color:#6a7785}.ho-grid.two{display:grid;grid-template-columns:1.25fr .75fr;gap:12px}.ho-panel{margin:0;padding:0}.ho-panel>header span{font-size:10px;color:#168447;font-weight:700}.status-bars,.approval-list{padding:15px}.status-bars>div{margin-bottom:12px}.status-bars label{display:flex;justify-content:space-between;font-size:11px;margin-bottom:5px}.status-bars i{display:block;height:9px;background:#e7ecf0}.status-bars em{display:block;height:100%}.approval-list p{display:flex;justify-content:space-between;border-bottom:1px solid #d9e0e6;padding:11px 0;margin:0}.approval-list b{color:#166534}.approval-list b.amber{color:#a8520d}.table-wrap{overflow:auto;margin:0 14px 14px;border:1px solid #46515c}.table-wrap table{width:100%;border-collapse:collapse;min-width:1000px;font-size:11px}.table-wrap th{background:#dfe6ed;color:#12345b;text-align:left;text-transform:uppercase;font-size:9px;padding:10px;border:1px solid #46515c}.table-wrap td{padding:10px;border:1px solid #46515c}.status-tag{display:inline-block;background:#e9f3ec;color:#166534;border:1px solid #9fc4aa;border-radius:3px;padding:4px 6px;font-size:9px;font-weight:700}.empty{text-align:center;padding:28px!important;color:#667482}@keyframes newsIn{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}@media(max-width:1200px){.module-grid{grid-template-columns:repeat(3,1fr)}.ho-kpis.six{grid-template-columns:repeat(3,1fr)}.quick{min-width:520px}}@media(max-width:900px){.welcome{align-items:stretch;flex-direction:column}.quick{min-width:0}.module-grid{grid-template-columns:repeat(2,1fr)}.ho-grid.two{grid-template-columns:1fr}.gov-head{height:auto;align-items:flex-start}.gov-right{flex-wrap:wrap}.news-window small{display:none}}@media(max-width:620px){.gov-head{padding:8px 12px}.gov-brand h1{font-size:17px}.gov-brand img{width:55px}.gov-right .date{display:none}.news{padding:0;grid-template-columns:auto 1fr}.news-nav{display:none}.news-window{font-size:11px}.news-window em{display:none}.ho-main{width:calc(100% - 24px);margin:12px auto}.quick{grid-template-columns:repeat(2,1fr)}.module-box>header{align-items:stretch;flex-direction:column;gap:10px}.module-box input{width:100%}.module-grid,.ho-kpis.six{grid-template-columns:1fr}.module-page>header{align-items:flex-start;flex-direction:column;gap:10px}}
.status-tag.pending{background:#fff4e5;color:#9a4d08;border-color:#e3ad72}.record-id{display:block;color:#728091;margin-top:4px;font-size:9px}.row-actions{display:flex;gap:6px}.row-actions button{border-radius:4px;padding:7px 10px;font-size:10px;font-weight:800;cursor:pointer}.row-actions button:disabled{opacity:.55;cursor:not-allowed}.approve-btn{background:#168447;color:#fff;border:1px solid #116a39}.delete-btn{background:#fff;color:#b42318;border:1px solid #b42318}.action-message{background:#eaf4ed;border:1px solid #8bb69a;color:#14532d;padding:11px 14px;font-size:12px;font-weight:700}.workflow-cards{display:grid;grid-template-columns:repeat(6,1fr)}.workflow-cards>div{padding:16px;border-right:1px solid #c8d1da}.workflow-cards>div:last-child{border:0}.workflow-cards span,.workflow-cards b{display:block}.workflow-cards span{font-size:9px;text-transform:uppercase;color:#657383}.workflow-cards b{margin-top:7px;color:#12345b;font-size:22px}@media(max-width:1200px){.workflow-cards{grid-template-columns:repeat(3,1fr)}}@media(max-width:620px){.workflow-cards{grid-template-columns:1fr}.row-actions{flex-direction:column}}
`;
